package com.gsb.vyapar.bhagya.datasource.cache

import kotlin.Long
import kotlin.String

public data class BusinessEntity(
  public val v: Long,
  public val d: String,
  public val i: Long,
  public val u: String,
)
